import { Action, Module, Mutation, VuexModule, getModule } from 'vuex-module-decorators';

import store from '@/store';
import { conduitApi } from '../api';
import { Invoice } from '../models/invoice';
import { ResponseSingle, Response, Meta } from '../models/response';
import { ULID } from '../models/uLID';
import { Query } from '../models';

@Module({
	namespaced: true,
	name: 'invoice',
	store,
	dynamic: true
})
class InvoiceModule extends VuexModule {
	invoice!: Invoice;

	invoices: Invoice[] = [];

	meta: Meta = {};

	@Mutation
	setAll(invoices: Response): void {
		this.invoices = invoices.data as Invoice[];
		this.meta = invoices.meta as Meta;
	}

	@Mutation
	set(invoice: ResponseSingle): void {
		this.invoice = invoice.data as Invoice;
	}

	@Action({ commit: 'setAll', rawError: true })
	async getAll(query: Query): Promise<Response> {
		try {
			const response = await conduitApi.get(`/customers/${query.customerID}/invoices`, {
				params: query.query
			});
			return response.data;
		} catch (error) {
			throw error;
		}
	}

	@Action({ commit: 'set', rawError: true })
	async get(id: ULID): Promise<ResponseSingle> {
		try {
			const response = await conduitApi.get(`/invoices/${id}`);
			return response.data;
		} catch (error) {
			throw error;
		}
	}
}

export default getModule(InvoiceModule);
